<template>
    <div>
        <Row>
            <span>标题：
                <Input v-model="searchItem['title.contains']" placeholder="" style="width: 170px" />
            </span>
            <span @click="handleSearch(0)" style="margin: 0 10px;"><Button type="primary" icon="md-search">{{$t('searchText')}}</Button></span>
            <Button @click="handleCancel" type="default" >{{$t('cancelText')}}</Button>
            <Button type="primary" shape="circle" icon="md-add" @click="handleCreateOrEditItem({id:0})">新建</Button>
        </Row>
        <hr style="margin:5px;"/>
        <Row class="margin-top-10 searchable-table-con1" style="width:100%">
            <Table :columns="columns" border :data="dataList" :row-class-name="rowClassName"></Table>
            <Row type="flex" justify="end" align="middle">
                <Page :total="dataCount" :current="currentPageNum+1" :page-size="pageSize" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
            </Row>
        </Row>
        <a ref="hrefToDownload" style="postion: absolute;left: -10px;top: -10px;width: 0px;height: 0px;"></a>
        <information-issue-view ref="showInformation"></information-issue-view>
    </div>
</template>

<script>
import Util from '../../libs/util.js'
import informationIssueView from './information_issue_view.vue'
import { getDate } from './information_public.js'
export default {
  name: 'policy',
  components: { informationIssueView },
  data () {
    return {
      dataCount: 0,
      currentPageNum: 0,
      pageSize: 10,
      columns: [],
      searchItem: { 'title.contains': '', 'sort': 'create_time,desc' },
      dataList: []
    }
  },
  methods: {
    init () {
      this.columsInit()
      this.handleSearch(0)
    },
    columsInit () {
      this.columns = [
        { title: '序号',
          align: 'center',
          width: 70,
          key: 'index',
          render: (h, params) => {
            return h('div', params.index + (this.currentPageNum) * this.pageSize + 1)
          }
        },
        { key: 'title', title: '标题' },
        { key: 'istop',
          title: '置顶',
          align: 'center',
          width: 70,
          render: (h, params) => {
            let _text = params.row.istop == 1 ? '是' : '否'
            return h('div', _text)
          }
        },
        { key: 'author', title: '作者', align: 'center' },
        { key: 'expirationTime',
          title: '失效时间',
          align: 'center',
          width: 120,
          render: (h, params) => {
            return h('div', getDate(params.row.expirationTime))
          }
        },
        { key: 'createTime',
          title: '创建时间',
          align: 'center',
          width: 120,
          render: (h, params) => {
            return h('div', getDate(params.row.createTime))
          }
        },
        { title: this.$t('operateText'),
          width: 270,
          key: 'handle',
          align: 'left',
          render: (h, params) => {
            let btn_view = h('Button',
              {
                props: { type: 'success', size: 'small' },
                on: {
                  click: () => {
                    let self = this
                    Util.http.get(`/api/system/cscpInformationIssues/${params.row.id}`).then(response => {
                      self.$refs.showInformation.showModel(response.data)
                    }).catch(error => {
                      if (error.response.data.message) {
                        self.$Notice.error({ title: '提示', desc: error.response.data.message })
                      }
                    })
                  }
                }
              },
              '查看'
            )
            let btn_edit = h('Button',
              {
                props: { type: 'primary', size: 'small' },
                on: {
                  click: () => {
                    this.handleCreateOrEditItem({ id: params.row.id })
                  }
                }
              },
              this.$t('editText')
            )
            let btn_shanchu = h('Poptip',
              {
                props: { confirm: true, title: '确定要删除吗？', transfer: true },
                style: { margin: '0 5px' },
                on: {
                  'on-ok': () => {
                    this.delete(params.row._index, params.row.id)
                  }
                }
              },
              [
                h('Button',
                  {
                    props: {
                      type: 'error',
                      placement: 'top',
                      size: 'small'
                    }
                  },
                  '删除'
                )
              ]
            )
            if (params.row.showContent == 'Y') {
              return h('div', [btn_edit, btn_shanchu, btn_view])
            } else {
              return h('div', [btn_edit, btn_shanchu])
            }
          }
        }
      ]
    },
    rowClassName (row, index) {
      if (row.istop == 1) {
        return 'istop'
      }
      return ''
    },
    search (argumentObj) {
      let self = this
      Util.http.get('/api/system/cscpInformationIssuesByCriteria?sort=istop,desc', { params: argumentObj }).then(function (response) {
        self.dataList = response.data.data
        self.dataCount = response.data.recordsTotal
      }).catch(function (error) {
        console.log(error)
      })
    },

    handleSearch (page) {
      this.searchItem.size = this.pageSize
      if (page != void 0) {
        this.searchItem.page = page
        this.currentPageNum = page
      }
      this.search(this.searchItem)
    },
    handleCancel () {
      this.searchItem = { 'title.contains': '', 'sort': 'create_time,desc', page: 1 }
      this.init()
    },
    handlePageChange (pageNum) {
      this.searchItem.size = this.pageSize
      this.searchItem.page = pageNum - 1
      this.currentPageNum = this.searchItem.page
      this.search(this.searchItem)
    },
    // 编辑
    handleCreateOrEditItem (argu) {
      this.$router.push({
        name: 'information_issue_edit',
        params: argu
      })
    },
    // 删除
    delete (index, id) {
      let self = this
      Util.http.delete('/api/system/cscpInformationIssues/' + id).then(function (response) {
        self.handleSearch()
        self.$Message.success(self.$t('successText'))
      }).catch(function (error) {
        console.log(error)
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>
.ivu-table .istop td{background-color:#f1faff;}
</style>
